import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { aceitarPoliticas, verificarAoEntrar } from '@/lib/consentimentoPoliticas'

// Pede ao cliente com sessão que aceite os Termos e a Privacidade quando ainda
// não aceitou a versão em vigor (26/10/2026): contas criadas com o Google,
// contas antigas (o "sim" de antes não tinha versão) e sempre que sair uma
// versão nova. Se o servidor falhar, não tranca a pessoa fora do site.
// Nas páginas dos próprios documentos o aviso não aparece (senão tapava o
// texto), nem no pedido sobre os dados (quem quer apagar a conta não tem de
// aceitar primeiro).
const PAGINAS_LEGAIS = ['/termos', '/privacidade', '/cookies', '/meus-dados']

export function AceitarPoliticas() {
  const { user } = useAuth()
  const { pathname } = useLocation()
  const [mostrar, setMostrar] = useState(false)
  const [aceite, setAceite] = useState(false)
  const [aEnviar, setAEnviar] = useState(false)
  const [erro, setErro] = useState<string | null>(null)

  useEffect(() => {
    if (!user?.id) {
      setMostrar(false)
      return
    }
    let cancelado = false
    verificarAoEntrar()
      .then((precisa) => { if (!cancelado) setMostrar(precisa) })
      .catch(() => { /* sem resposta: não bloqueia */ })
    return () => { cancelado = true }
  }, [user?.id])

  if (!mostrar || PAGINAS_LEGAIS.includes(pathname)) return null

  const confirmar = async () => {
    setAEnviar(true)
    setErro(null)
    try {
      await aceitarPoliticas('aviso_site')
      setMostrar(false)
    } catch {
      setErro('Não foi possível guardar. Verifique a ligação e tente de novo.')
    } finally {
      setAEnviar(false)
    }
  }

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/50 p-4 sm:items-center" role="dialog" aria-modal="true" aria-labelledby="aceitar-politicas-titulo">
      <div className="w-full max-w-md rounded-xl bg-white p-5 shadow-2xl">
        <h2 id="aceitar-politicas-titulo" className="text-lg font-semibold text-gray-900">Termos e Privacidade</h2>
        <p className="mt-2 text-sm text-gray-700">
          Para continuar a usar a TaMoAki, leia e aceite as versões em vigor dos nossos documentos.
        </p>
        <label className="mt-4 flex items-start gap-3 text-sm text-gray-800">
          <input type="checkbox" className="mt-0.5 h-4 w-4 shrink-0" checked={aceite} onChange={(e) => setAceite(e.target.checked)} />
          <span>
            Li e aceito os{' '}
            <Link to="/termos" target="_blank" className="text-blue-600 underline">Termos de Uso</Link>
            {' '}e a{' '}
            <Link to="/privacidade" target="_blank" className="text-blue-600 underline">Política de Privacidade</Link>.
          </span>
        </label>
        {erro && <p role="alert" className="mt-3 text-sm text-red-700">{erro}</p>}
        <button
          onClick={confirmar}
          disabled={!aceite || aEnviar}
          className="mt-5 w-full rounded-lg bg-blue-600 py-2.5 font-semibold text-white disabled:opacity-50"
        >
          {aEnviar ? 'A guardar…' : 'Continuar'}
        </button>
      </div>
    </div>
  )
}
